import {JSEncrypt} from "jsencrypt";

async function loadPublicKey() {
    const response = await fetch('/public.pem');
    const publicKeyPem = await response.text();
    return publicKeyPem;
}

export async function encryptPassword(password) {
    try{
        const pKey = await loadPublicKey();
        if (pKey) {
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(pKey);
            let encryptedPassword = encrypt.encrypt(password);

            return encryptedPassword;
        } else {
        }
    } catch (e) {
    }

}

export function encodeToBase64Unicode(input) {
    try {
        const utf8Bytes = new TextEncoder().encode(input);
        const encoded = btoa(String.fromCharCode(...utf8Bytes));
        return encoded;
    } catch (e) {
        return null;
    }
}
export async function generateKey() {
    const key = await crypto.subtle.generateKey(
        {
            name: "AES-GCM",
            length: 256, // 256-bit ключ для AES
        },
        true, // Экспортируемый
        ["encrypt", "decrypt"]
    );
    return key;
}
export async function decryptAES(key, ciphertextBase64) {
    // Декодируем base64
    const cipherArray = new Uint8Array(atob(ciphertextBase64).split("").map(c => c.charCodeAt(0)));

    // Извлекаем nonce (первые 12 байт)
    const iv = cipherArray.slice(0, 12);
    const ciphertext = cipherArray.slice(12);

    // Расшифровываем данные с помощью AES-GCM
    const decrypted = await crypto.subtle.decrypt(
        {
            name: "AES-GCM",
            iv: iv,
        },
        key,
        ciphertext
    );

    // Преобразуем обратно в строку
    const decoder = new TextDecoder();
    return decoder.decode(decrypted);
}
export async function encryptAES(key, plaintext) {
    // Преобразуем строку в ArrayBuffer
    const encoder = new TextEncoder();
    const data = encoder.encode(plaintext);

    // Генерируем случайный nonce (12 байт для AES-GCM)
    const iv = crypto.getRandomValues(new Uint8Array(12));

    // Шифруем данные с помощью AES-GCM
    const cipher = await crypto.subtle.encrypt(
        {
            name: "AES-GCM",
            iv: iv,
        },
        key,
        data
    );

    // Возвращаем результат в формате base64 (nonce + ciphertext)
    const cipherArray = new Uint8Array(cipher);
    const result = new Uint8Array(iv.length + cipherArray.length);
    result.set(iv);
    result.set(cipherArray, iv.length);

    // Кодируем в base64
    return btoa(String.fromCharCode(...result));
}
